// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"33":"css/admin-app.6834","2107":"css/app.6834"}[chunkId] + ".css";
};